// https://en.wikipedia.org/wiki/PJW_hash_function
export const hashDigitalAsset = (id: string, radix: number) => {
  let hash = 0;
  for (let i = 0; i < id.length; ++i) {
    hash = (hash << 4) + id.charCodeAt(i);
    const g = hash & 0xf0000000;
    if (g) {
      hash ^= g >> 24;
    }
    hash &= ~g;
  }
  return hash % radix;
};
